import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import coverImage from '../assets/cover.png';

export function Hero() {
  const { t } = useLanguage();

  const scrollToAbout = () => {
    const element = document.getElementById('ai-runner');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        paddingTop: '300px',
        paddingBottom: '100px',
        boxSizing: 'border-box'
      }}
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${coverImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: '#000',
        }}
      />
      <div className="absolute inset-0 bg-black/40" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="backdrop-blur-lg bg-white/10 rounded-2xl p-8 shadow-xl border border-white/10 max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 animate-fade-in">
            {t('hero_headline').split('\n').map((line, i) => (
              <div key={i} className={i > 0 ? 'mt-4' : ''}>{line}</div>
            ))}
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            {t('hero_tagline')}
          </p>
        </div>
      </div>

      <button
        onClick={scrollToAbout}
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white animate-bounce"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
}
